export default {
  ecosystem: {
    subtitle: "لماذا ماهال",

    title1: "كن جزءًا من",
    title2: "نظام ماهال",

    desc:
      "ماهال ليست مجرد منصة — بل نظام متكامل يربط بين المطاعم والموردين والمهنيين للنمو معًا.",

    text:
      "كن جزءًا من شبكة متنامية من المطاعم والموردين الذين يغيرون طريقة التوريد من خلال الشفافية والكفاءة والشراكات طويلة الأمد — عبر منصة رقمية موحدة.",

    cta: "انضم إلى أكثر من 500 شركة",
  },
};